import React, { useEffect } from 'react';
import { View } from 'src/components/basic';
import { scssVariables as variables, useScreenDetail } from 'src/helpers';
import Message from './Message';
import { MIN_DESKTOP_WIDTH, remCss } from '../utils';
import { Managers } from './Managers';
import locationsModel from '../locationsModel';
import { Locations } from './Locations';
import { SubLocation } from './Location';
import managersModel from '../managersModel';

const Content = ({
  manager,
  location,
  isConv,
  clinic,
  onChatSupport,
  onLocation,
  onBack,
  emptyManagers
}) => {
  const screen = useScreenDetail();
  return (
    <View style={{ gap: remCss(25), height: '100%', overflow: 'auto' }}>
      <View
        style={{
          flexDirection: 'row',
          flex: 1,
          height: '100%',
          overflow: 'auto'
        }}
      >
        {isConv ? (
          <Message key={manager?.id || manager?.userId || 'manager'} contact={manager} onBack={onBack} />
        ) : (
          <Locations
            emptyManagers={emptyManagers}
            manager={manager}
            clinic={clinic}
            onChatSupport={onChatSupport}
            onLocation={onLocation}
          />
        )}
        {isConv && MIN_DESKTOP_WIDTH <= screen.innerWidth && location?.id && (
          <View
            style={{
              paddingLeft: remCss(30),
              borderLeftColor: variables['colors-mc-border2'],
              borderLeftWidth: 2,
              borderLeftStyle: 'solid',
              paddingTop: 0,
              height: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              width: '35%',
              maxWidth: remCss(380),
              outline: 'none',
              position: 'relative'
            }}
          >
            <View style={{ height: '100%', position: 'absolute', top: 0, width: '100%' }}>
              <SubLocation
                manager={manager}
                clinic={clinic}
                onChatSupport={null}
                onLocation={onLocation}
                isConv={isConv}
                isLeft={true}
                location={location}
              />
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export const ContactTab = ({
  isConv,
  onChatSupport,
  clinic,
  onManagerItem,
  medium,
  onLocation,
  onBack,
  contentStyle
}) => {
  const screen = useScreenDetail();
  locationsModel.use();
  const [isEmpty, setIsEmpty] = React.useState(
    managersModel.getListState('recent').items.length === 0
  );

  const emptyManager = React.useCallback((items) => {
    setIsEmpty(!items.length);
  }, []);

  useEffect(() => {
    managersModel.on('ClinicProfileManagersModel_refresh', emptyManager);
    return () => {
      managersModel.cancel('ClinicProfileManagersModel_refresh', emptyManager);
    };
  }, [emptyManager]);

  const manager = locationsModel.state.manager || {};
  const location = locationsModel.state.location || {};
  return (
    <>
      <View
        data-testid={'public-contact-tab'}
        style={{
          ...contentStyle,
          flexDirection: 'row',
          minHeight: screen.innerHeight - remCss(medium ? 270 : 360)
        }}
      >
        <Managers onManagerItem={onManagerItem} />
        <View
          style={{
            flex: 1,
            borderLeftColor: variables['colors-mc-border2'],
            borderLeftWidth: 2,
            borderLeftStyle: 'solid'
          }}
        >
          <Content
            isConv={isConv}
            onChatSupport={onChatSupport}
            emptyManagers={isEmpty}
            manager={manager}
            medium={medium}
            location={location}
            clinic={clinic}
            onLocation={onLocation}
            onBack={onBack}
          />
        </View>
      </View>
    </>
  );
};
